import { c as _c } from "react/compiler-runtime";
import { P } from '@/components/Atoms/P/P';
import { Prose } from '@/components/Atoms/Prose/Prose';
import { H2 } from '@/components/Core/Heading';
import Empty from '@/components/Icons/Empty';
import useTranslation from '@/hooks/useTranslation';
import type { FC } from 'react';
import styles from './EmptyState.module.css';
export const EmptyState: FC<{
  title?: string;
  description?: string;
}> = t0 => {
  const $ = _c(14);
  const {
    title,
    description
  } = t0;
  const {
    t
  } = useTranslation("common");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Empty className={styles.icon} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t || $[2] !== title) {
    t2 = title ?? t("Feedback.no_results");
    $[1] = t;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <H2>{t2}</H2>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== description || $[7] !== t) {
    t4 = description ?? t("Filter.no_results");
    $[6] = description;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <P>{t4}</P>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <div className={styles.emptyState}>{t1}<Prose>{t3}{t5}</Prose></div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};